import { Enum } from 'src/app/models/enum.model';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { countries } from 'src/app/resources/countries';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { images } from 'src/app/resources/images';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { BaseHttpResult } from 'src/app/models/base-http-response';
import { ApiService } from 'src/app/services/http/api.service';
import { Anomaly } from 'src/app/models/anomaly.model';


@Component({
    selector: 'app-anomaly-form-component',
    templateUrl: './anomaly-form.component.html'
})
export class AnomalyFormComponent extends DialogContentBase implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public countries = countries;
    public listItems: Array<Enum> = [];
    public data = ['PT', 'EN', 'FR']
    public avatars?: NodeList;
    public placeHolder: any = {
        nome: "<Selecionar>",
        id: 0,
    };
    public formValue: Anomaly = {
        codigo: '',
        nome: '',
        traducoes: [
            { refLingua: 1, valor: '', descricaoLingua: '', id: 0 },
            { refLingua: 2, valor: '', descricaoLingua: '', id: 0 },
            { refLingua: 3, valor: '', descricaoLingua: '', id: 0 }
        ],
        id: 0,
    };
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private notificationService: NotificationService, private api: ApiService, public override dialog: DialogRef) {
        super(dialog);
        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
    }

    ngOnInit(): void {
    }

    public inputBlur() {
        if (this.formGroup.controls['en'].value == '' && this.formGroup.controls['fr'].value == '' && this.formValue.id == 0) {
            var texto = this.formGroup.controls['pt'].value;
            this.formGroup.controls['en'].setValue(texto);
            this.formGroup.controls['fr'].setValue(texto);
        }
    }

    public setFormValues() {
        var ptValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor;
        var enValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 2)[0].valor;
        var frValue = this.formValue.traducoes.filter(_ling => _ling.refLingua === 3)[0].valor;
        this.formGroup = new FormGroup({
            pt: new FormControl(ptValue),
            en: new FormControl(enValue),
            fr: new FormControl(frValue),
            codigo: new FormControl(this.formValue?.codigo),
        });
    }

    public saveChanges(): void {
        this.formGroup.markAllAsTouched();
        this.formValue.codigo = this.formGroup.controls['codigo'].value;
        this.formValue.traducoes.filter(_ling => _ling.refLingua === 1)[0].valor = this.formGroup.controls['pt'].value;
        this.formValue.traducoes.filter(_ling => _ling.refLingua === 2)[0].valor = this.formGroup.controls['en'].value;
        this.formValue.traducoes.filter(_ling => _ling.refLingua === 3)[0].valor = this.formGroup.controls['fr'].value;
        const formValues = JSON.stringify(this.formValue);
        this.api.save<BaseHttpResult>('Anomalia/SaveAnomalia', this.formValue).then(res => {
            if (res.ok) {
                this.formGroup.markAsPristine();
                this.notificationService.show({
                    content: this.customMsgService.translate('registoGravadoComSucesso'),
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'bottom' },
                    type: { style: 'success', icon: true },
                    hideAfter: 2000
                });
                this.dialog.close({ text: "Submit", themeColor: "primary" });
            } else {
                this.notificationService.show({
                    appendTo: this.container,
                    content: res.message,
                    animation: { type: 'slide', duration: 500 },
                    position: { horizontal: 'center', vertical: 'top' },
                    type: { style: 'error', icon: true },
                    hideAfter: 4000
                });
            }
        });
    }

    public onCancelAction(): void {
    }

    public onConfirmAction(): void {
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

    public flagURL(country: string): string {
        const code: string = country;
        const image: any = images;

        return image[code];
    }

}
